/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ColorConfiguration {
    getFixupPrototypeFunction() { return ColorConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ColorConfiguration>): ColorConfiguration {
        let obj = Object.assign(new ColorConfiguration(), model);
        ColorConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ColorConfiguration>): ColorConfiguration {
        if (!model) return null;
        return ColorConfiguration.newInstance(<ColorConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ColorConfiguration) {
        if (!obj) return;

        models.ColorConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ColorConfiguration): boolean {
        Object.setPrototypeOf(obj, ColorConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.segments) {
            for (let val of this.segments) {
                models.ColorSegment.fixupPrototype(val);
            }
        }
    }

    segments: Array<models.ColorSegment>;

    paletteName: string;

}
